import React, {useState,  useEffect } from 'react';
import DeckGL, { OrthographicView } from 'deck.gl';

import { _GeoJSONLoader as GeoJSONLoader } from "@loaders.gl/json";

import zipLoader from './zipLoader'


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    width: window.innerWidth,
    height: window.innerHeight,
    target: [512 * 2.5, 512 * 2.5],
    zoom: -2
};


function Map() {

    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE)

    return (
        <div>
            <DeckGL
                views={new OrthographicView()}
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ })}
                //onViewStateChange={(v)=>console.log(v.viewState)}
            >
            </DeckGL>
            <div id="fieldset">
                <legend>Analog map generated by stable diffusion</legend>
            </div>
            
        </div>
    );
}

export default Map;